<!-- product details page design -->

<!-- banner section start-->
<main>
  <div class="hide-acc">
    <div class="container-box">
      <div class="alert valign-children-middle mar-top-20" *ngIf="detailErrorMessage!=null">
        <div class="alert-error" aria-label="Alert.">
          <i class="icon-badgealert" aria-hidden="true"></i>
        </div>
        <div>
          <h2 tabindex="-1">Error</h2>
          <p>{{detailErrorMessage}}</p>
        </div>
      </div>
    </div>

    <div class="flex-container" *ngIf="submitting">
      <div class="flex-item">
        <img class="submitting" src="assets/img/spinner.svg" alt="submitting" />
      </div>
    </div>

    <div *ngIf="formSuccess">
      <div class="container-box">
        <div class="alert valign-children-middle">
          <div class="alert-success">
            <i class="icon-approval" aria-hidden="true"></i>
          </div>
          <div>
            <h2 tabindex="-1">Success</h2>
            <p>{{formSubmitSuccessMsg}}</p>
          </div>
        </div>
      </div>
    </div>

    <section aria-labelledby="bannerNameSection" *ngIf="!checkEFotaPage">
      <div class="banner-section">
        <figure>
          <img class="hide-sm" src="{{productDetail.media && productDetail.media.largeImageUrl}}" alt="Banner Image" />
          <img class="show-sm" src="{{productDetail.media && productDetail.media.smallImageUrl}}" alt="Banner Image" />
        </figure>

        <div class="banner-caption" *ngIf="productDetail != null">
          <div class="container-box">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <h1 id="bannerNameSection" [innerHTML]="productDetail.bannerName"></h1>
                <p class="col-sm-12 col-md-7 product-text"
                  [innerHTML]="productDetail.plainDescription"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section aria-labelledby="efotaBannerNameSection" *ngIf="checkEFotaPage">
      <div class="banner-section">
        <figure>
          <img class="hide-sm" src="{{productDetail.media && productDetail.media.largeImageUrl}}" alt="E-FOTA Banner Image" />
          <img class="show-sm" src="{{productDetail.media && productDetail.media.smallImageUrl}}" alt="E-FOTA Banner Image" />
        </figure>

        <div class="banner-caption" *ngIf="productDetail != null">
          <div class="container-box">
            <div class="row">
              <div class="col-sm-12 col-md-6" role="heading" aria-level="1">
                <h1 id="efotaBannerNameSection" [innerHTML]="productDetail.bannerName"></h1>
                <p class="col-sm-12 col-md-7 efota-product-text"
                  [innerHTML]="productDetail.plainDescription"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- banner section end-->
  
    <!-- products info section start here-->
    <section aria-labelledby="packageLabelNameSection" class="package-section" *ngIf="subscriptionCardArray.length > 0">
      <div class="container-box">
        <h2 id="packageLabelNameSection" class="text-center product-style">{{packageLabelName}}</h2>
        <p align="center" *ngIf="packageLabelName" class="msg label-style">Your account discount price and bill credits
          might not be reflected until you select billing account during checkout.</p>
        <div class="alert valign-children-middle" *ngIf="permissionFlag || alreadyOwnedProduct">
          <div class="alert-info" aria-label="Information">
            <i class="icon-flat-info"></i>
          </div>
          <div *ngIf="permissionFlag">
            <h2>You don't have buy permissions, continue to learn. Contact your Admin</h2>
          </div>
          <div *ngIf="alreadyOwnedProduct">
            <h2>Your organization has already purchased this product. Either manage this product or buy a new product
              using your
              wireless number.</h2>
          </div>
        </div>
        <!--<div class="text-center" *ngIf="permissionFlag">You don't have buy permissions, continue to learn. Contact your TCM.</div>-->
        <div class="display-column">
          <article class="package-tile" *ngFor="let subscripitioncard of subscriptionCardArray">
            <app-subscription-card [subscripitioncard]="subscripitioncard" (skuId)="handleSubscriptionEvent($event)"
              (pageLoaderEvent)="pageLoadEvent($event)"></app-subscription-card>
          </article>
        </div>
        <div class="clearfix"></div>
      </div>
    </section>
    <!-- products info section end here-->
  
    <!-- TAB section start here-->
    <section aria-label="Tabs Section">
      <div class="container-box details-page">
        <!--<app-tab [options]="tabDetails"></app-tab>-->
        <app-tabs [tabs]="tabDetails" [ariaLabel]="productDetail.bannerName" *ngIf='showTab'>
          <app-tab class="app-tab" *ngFor="let td of tabDetails" [option]="td">
            <div *ngIf="checkEFotaPage" [innerHTML]="td.blankMessage"></div>
            <div *ngIf="!checkEFotaPage" [innerHTML]="td.totalDescription"></div>
            <ng-container *ngIf="td['formConfig'] && fullPermit && efotaNotEnrollFans ; else FullAuthenticated">
              <div class="alert valign-children-middle mar-top-20">
                <div class="alert-error" aria-label="Alert.">
                  <i class="icon-badgealert" aria-hidden="true"></i>
                </div>
                <div>
                  <h2 [innerHTML]="td.noFansMessage"></h2>
                </div>
              </div>
            </ng-container>

            <ng-template #FullAuthenticated>
              <ng-container *ngIf="td['formConfig'] && fullPermit ; else partiallyAuthenticated">
                <!-- <div id="descriptionEfota" [innerHTML]="td.description" *ngIf="checkEFotaPage"></div>
                <p class="bold-text" *ngIf="checkEFotaPage" [innerHTML]="td.requiredFields"></p> -->
                <app-form-builder [formConfig]="td['formConfig']" [formName]="td['formName']"
                  (formOutput)="getFormConfigDetails($event, td)"></app-form-builder>
                <section aria-labelledby="submitSection" class="buttons-section col-sm-12 col-md-12 text-right" *ngIf="!checkEFotaPage">
                  <hr>
                  <div>
                  
                  <button id="submitSection" [disabled]="!td['formValid']" (click)="submit(td)"
                    class="btn btn-secondary">{{productDetail.submit}}</button>
                    </div>
                </section>
                <a href="/businessconsole/efota/enrollment" *ngIf="td['formConfig'] && checkEFotaPage"><button id="loginBtn4"
                  class="btn">{{productDetail.startEnrollment}}</button></a>
              </ng-container>

            </ng-template>

            <ng-template #partiallyAuthenticated>
              <ng-container *ngIf="td['formConfig'] && NotFullPermit ; else unAuthenticated">
                <div class="alert valign-children-middle mar-top-20">
                  <div class="alert-error" aria-label="Alert.">
                    <i class="icon-badgealert" aria-hidden="true"></i>
                  </div>
                  <div>
                    <h2 [innerHTML]="td.permissionMessage"></h2>
                  </div>
                </div>
              </ng-container>
            </ng-template>

            <ng-template #unAuthenticated>
              <p id="unAuthFormText" *ngIf="td['formConfig']">{{productDetail.unAuthenticatedDescription}}</p>
              <a href="/businessconsole/login?rkey=efotaoffer" *ngIf="td['formConfig']"><button id="loginBtn1"
                  class="btn">{{productDetail.login}}</button></a>
            </ng-template>
            
            <div class="tab-moreinfo" *ngIf='td.id == "Overview"'>
              <p></p>
              <p *ngIf="learnUrl ?.length > 0"><a
                  [attr.aria-label]=" 'Go to the ' + productDetail.displayName + ' website to learn more - opens a dialog box' "
                  href="javascript:void(0)" (click)="showLearnDetails($event);"> Go to the {{productDetail.displayName}}
                  website to learn more</a></p>
            </div>

            <div class="tab-unauthinfo"
              *ngIf='td.key == "subscription" && authSubscription; else unAuthenticatedSubscription'>
              <div id="subscriptionContent">
                <p class="tabHeading" [innerHTML]="td.heading"></p>
                <p [innerHTML]="td.subHeading"></p>
                <br>
                <img src="{{productDetail.media && productDetail.media.groupBasedUrl}}" alt="E-FOTA">
                <img src="{{productDetail.media && productDetail.media.accountBasedUrl}}" alt="E-FOTA">
                <br><br>
                <div>
                  <p [innerHTML]="td.eligibleDevices"></p>
                </div>
              </div>
            </div>

            <ng-template #unAuthenticatedSubscription>
              <div *ngIf='td.key == "subscription" && unAuthSubscription'>
                <p class="plainText" [innerHTML]="td.subHeading"></p>
                <br>
                <p class="tabHeading">{{productDetail.unAuthenticatedPricingDescription}}</p>
                <a href="/businessconsole/login?rkey=efotaoffer"><button id="loginBtn2" class="btn">{{productDetail.login}}</button></a>
              </div>
            </ng-template>

          </app-tab>
        </app-tabs>
      </div>
    </section>
    <section aria-label="Terms of use" *ngIf="productDetail?.tncUrl ?.length > 0" class="package-section">
      <div class="container-box">
        <div class="tnc">
          <!-- <p class="pre-text"> This is a legal disclosure. </p> -->
          <p>{{productDetail.displayName}} is subject to its <a
              [attr.aria-label]=" productDetail.displayName + 'is subject to its Terms of Use. (Opens in new window)' "
              href="{{this.productDetail.tncUrl}}" target="_blank">
              Terms of Use.
            </a>
          </p>
        </div>
      </div>
    </section>
  </div>
  <!--TAB section end here-->
  <!-- model popup here -->
  <div *ngIf="termsConditionPopup">
    <app-terms-content [showModal]="termsConditionPopup" [title]='productDetail.displayName'
      [triggerElement]='eventEmit' [contentUrl]="contentUrl" (modalOutput)="updateTermsCondition($event)">
    </app-terms-content>
  </div>
  <div *ngIf="learnPopup">
    <app-modal [showModal]="learnPopup" [modalClass]="modalClass">
      <app-confirm-modal [modalPopupObject]='confirmModalPopup' [triggerElement]='eventEmit'
        (modalOutput)="updateLearnDetails($event)">
      </app-confirm-modal>
    </app-modal>
  </div>
  <app-mobile-pivot [pivots]="pivots"></app-mobile-pivot>
</main>